export const CONFIG_GLOBAL = Object.freeze({
    REACT_APP_HTTP_MOCK_ON:'false',
    REACT_APP_CYPRESS_AUTHENTICATED:'false',
    REACT_APP_CYPRESS_PROFILE:'admin',
    REACT_APP_MSAL_AUTH_AUTHORITY:'https://login.microsoftonline.com/organizations',
    REACT_APP_GRAPH_API_URL:'https://graph.microsoft.com/v1.0',
    REACT_APP_MAX_ITENS_TABLE:10,
    REACT_APP_MESSAGE_EXPIRED_AZURE_TOKEN:'Lifetime validation failed, the token is expired.',
    REACT_APP_MESSAGE_EXPIRED_TIMESTAMP_TOKEN:'"exp" claim timestamp check failed',
    REACT_APP_MESSAGE_REQUEST_401: 'Request failed with status code 401'
})